<template>
  <div class="monitorMsgPage">
    <LivePlayer
      :videoUrl="playData.deviceParams"
      autoplay
      live
      stretch
      playsinline
      webkit-playsinline
      x5-playsinline
      x-webkit-airplay="allow"
      class="video-js vjs-default-skin mb10 mySelfVideo"
    ></LivePlayer>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/

const refreshPage = () => import("@/components/common/refreshPage");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "videoPage",
  components: {
    refreshPage,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      playData: {},
      monitorId: "",
      myVideo: null,
      userToken: "",
      refreshPage: false, //网络失败

      clientType: "", //手机类型
    };
  },

  mounted() {
    document.title = "监测点";
    this.clientType = getDeviceType();
    this.userToken = this.$route.query.token;
    this.monitorId = this.$route.query.commonId;
    this.initPage();
  },

  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .geoMonitor({
          objid: _this.monitorId,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.playData = res.data;
            _this.$set(_this.playData, "deviceParams", res.data.deviceParams);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less">
.monitorMsgPage {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #f6f6f6;
  .mySelfVideo {
    width: 100%;
    height: 100%;
    position: relative;
    .vjs-big-play-button {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
</style>